import dayjs from "dayjs";

import type { Point } from "./types";

/**
 * Downsample a daily series to at most `target` fixed-width time buckets for the
 * navigator sparkline. Buckets sum the values they contain (preserves volume
 * shape — not LTTB). Returns the input unchanged when it already fits.
 */
export function bucketToTarget(points: Point[], target = 150): Point[] {
  if (points.length <= target) return points;
  const days = points.map((p) => dayjs(p.x));
  const first = days.reduce((a, b) => (b.isBefore(a) ? b : a));
  const last = days.reduce((a, b) => (b.isAfter(a) ? b : a));
  // Span includes the final day, so an N-day window yields at most `target` buckets.
  const width = Math.ceil((last.diff(first, "day") + 1) / target);
  const sums = new Map<number, number>();
  points.forEach((p, i) => {
    const k = Math.floor(days[i].diff(first, "day") / width) * width;
    sums.set(k, (sums.get(k) ?? 0) + p.y);
  });
  return Array.from(sums.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([k, y]) => ({ x: first.add(k, "day").format("YYYY-MM-DD"), y }));
}
